/* eslint-disable default-param-last */
import { activeJobsConstants } from './creator';

export const activeJobsModuleInitialState = {
  jobs: [], selectedJob: null, userChanges: {},
};

const MAPPED_REDUCERS = {

  [activeJobsConstants.SET_JOBS]: (state, { payload, meta = {} }) => ({
    ...state,
    jobs: [...(meta.append ? state.jobs : []), ...payload],
  }),
  [activeJobsConstants.SET_SELECTED_JOB_DETAILS]: (state, { payload, meta = {} }) => ({
    ...state,
    selectedJob: {
      ...(meta.update && state.selectedJob),
      ...payload,
    },
  }),
 [activeJobsConstants.SET_SELECTED_SEARCH_CONFIG]: (state, { payload: selectedSearchConfig }) => ({
    ...state,
    selectedJob: {
      ...state.selectedJob,
      selectedSearchConfig,
    },
  }),

};

function activeJobsReducer(state = activeJobsModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default activeJobsReducer;
